import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch } from 'vue'
    import { useId, useOrganizationUnitId, useRouter } from '@common/composables'
    import { useAdminRunDetailsPage } from '@Integrations/Runs/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminRunDetailsPage',
  setup(__props) {

    const router = useRouter()
    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        useRunDetailsQuery,
        useDeleteRunCommand,
        usePermanentDeleteRunCommand,
    } = useAdminRunDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelRunDetailsQueryV1, runRunDetailsQueryV1 } = useRunDetailsQuery(tid, id, true)
    const pipelineName = computed(() => modelRunDetailsQueryV1.value?.PipelineName || [])
    const log = computed(() => modelRunDetailsQueryV1.value?.Log || [])
    const isDeleted = computed(() => modelRunDetailsQueryV1.value?.IsDeleted)

    const { invokeDeleteRunCommandV1, succeedDeleteRunCommandV1 } = useDeleteRunCommand(id, tid, userId)
    const { invokePermanentDeleteRunCommandV1, succeedPermanentDeleteRunCommandV1 } = usePermanentDeleteRunCommand(id)

    onMounted(() => {
        runCurrentUserQueryV1()
        runRunDetailsQueryV1()
    })

    watch(succeedDeleteRunCommandV1, () => runRunDetailsQueryV1())

    watch(succeedPermanentDeleteRunCommandV1, (val) => val ? router.push(`/admin/integrations/runs/manage/${tid}`) : null)

    function handleDeleteRunCommandV1() {
        if (confirm(`Do you really want to delete run ${id}?`)) invokeDeleteRunCommandV1()
    }

    function handlePermanentDeleteRunCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete run ${id}?`)) invokePermanentDeleteRunCommandV1()
    }

return { __sfc: true,router, tid, id, useCurrentUserQuery, useRunDetailsQuery, useDeleteRunCommand, usePermanentDeleteRunCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, modelRunDetailsQueryV1, runRunDetailsQueryV1, pipelineName, log, isDeleted, invokeDeleteRunCommandV1, succeedDeleteRunCommandV1, invokePermanentDeleteRunCommandV1, succeedPermanentDeleteRunCommandV1, handleDeleteRunCommandV1, handlePermanentDeleteRunCommandV1 }
}

})